import http from 'axios'
import { show } from 'features/Toasts/Toasts.actions.js'

export const getCases = () => ({
  type: 'CASES/GET_CASES',
  payload: http({
    method: 'GET',
    url: 'api/v1/cases',
    params: {
      limit: '1000',
    },
  }),
})

export const getServiceCases = serviceId => ({
  type: 'CASES/GET_SERVICE_CASES',
  payload: http({
    method: 'GET',
    url: `api/v1/services/${serviceId}/cases`,
  }),
  meta: {
    serviceId,
  },
})

export const getOutages = () => ({
  type: 'CASES/GET_OUTAGES',
  payload: http({
    method: 'GET',
    url: 'api/v1/cases/outages',
    params: {
      limit: '1000',
    },
  }),
})

export const createBillingDispute = ({
  ban,
  invoice,
  number,
  disputedAmount,
  description,
}) => dispatch =>
  dispatch({
    type: 'CASES/CREATE_BILLING_DISPUTE',
    payload: http({
      method: 'POST',
      url: `api/v1/cases/ban/${ban}/dispute`,
      data: {
        invoice,
        number,
        disputedAmount,
        description,
      },
    }),
  }).then(() =>
    dispatch(
      show({
        title: 'A new support case hase been created.',
      })
    )
  )

export const createEnquiry = ({ ban, type, description }) => dispatch =>
  dispatch({
    type: 'CASES/CREATE_ENQUIRY',
    payload: http({
      method: 'POST',
      url: `api/v1/cases/ban/${ban}/enquiry`,
      data: {
        type,
        description,
      },
    }),
  }).then(() =>
    dispatch(
      show({
        title: 'A new support case hase been created.',
      })
    )
  )

export const createTroubleTicket = ({
  serviceId,
  symptom,
  impact,
  repeatFault,
  description,
}) => dispatch =>
  dispatch({
    type: 'CASES/CREATE_TROUBLE_TICKET',
    payload: http({
      method: 'POST',
      url: 'api/v1/cases/trouble-ticket',
      data: {
        serviceId,
        symptom,
        impact,
        repeatFault,
        description,
      },
    }),
  }).then(() =>
    dispatch(
      show({
        title: 'A new support case hase been created.',
      })
    )
  )

export const getTroubleTicket = caseId => ({
  type: 'CASES/GET_TROUBLE_TICKET',
  payload: http({
    method: 'GET',
    url: `api/v1/cases/${caseId}/trouble-ticket`,
  }),
})

export const addTroubleTicketNote = ({ caseId, note }) => ({
  type: 'CASES/ADD_TROUBLE_TICKET_NOTE',
  payload: http({
    method: 'PUT',
    url: `api/v1/cases/${caseId}/trouble-ticket`,
    data: {
      note,
    },
  }),
})



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cases/Cases.actions.js